module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "big-slogan-blue"
  }, [_vm._v(_vm._s(_vm.$t("about.pageHeader")))])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "all-categories mb-20"
  }, [_vm._v("\n\t\t\t\t\t\t \n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.$t("about.sloganTop")) + "At "), _vm._m(0), _vm._v(", our mission is to empower people to unite around ideas that matter to them and together make those ideas come to life.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.descriptionLineOne")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.descriptionLineTwo")))]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.$t("about.sloganBottom")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "all-categories mb-20"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("contactForm.title")))])]), _vm._v(" "), _c('form', [_c('input', {
    staticClass: "form-control mb-20",
    attrs: {
      "type": "text",
      "id": "guest-email",
      "placeholder": _vm.$t('contactForm.email')
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control mb-20",
    attrs: {
      "type": "text",
      "id": "guest-subject",
      "placeholder": _vm.$t('contactForm.subject')
    }
  }), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "8",
      "id": "guest-comment",
      "placeholder": _vm.$t('contactForm.message')
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t("contactForm.sendButton")))])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('why-do-more'), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sub', [_c('span', {
    staticClass: "logo-font domore-yellow"
  }, [_vm._v("do")]), _c('span', {
    staticClass: "logo-font domore-blue-1"
  }, [_vm._v("MORE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid mt-30 mb-30 p-0"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/img/domore-about.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9b4663a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About/About.vue
// module id = 834
// module chunks = 1